import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

function AutoRedirect() {
  const history = useHistory();

  useEffect(() => {
    // Open the new URL in a new tab
    window.open("http://arreportsql/Reports/report/THRaporlar/Genel/ServisAraclar%C4%B1VeFotograflar%C4%B1", '_blank');

    // Go back to the previous URL
    history.goBack();
  }, [history]);

  // Return null to render nothing
  return null;
}

export default AutoRedirect;
